import KT01BaseLayout from 'general/components/BaseLayout/KT01BaseLayout';
import { Route, Routes } from 'react-router-dom';
import LandownerReconciliationReportListScreen from './screens/LandownerReconciliationReportListScreen';

function LandownerReconciliationReport(props) {
  return (
    <KT01BaseLayout>
      <div className="container-fluid">
        <Routes>
          <Route path="" element={<LandownerReconciliationReportListScreen />} />
          <Route path="*" element={<>Not found</>} />
        </Routes>
      </div>
    </KT01BaseLayout>
  );
}

export default LandownerReconciliationReport;
